export default __webpack_public_path__ + "static/mobile-apps-speak-confidently-ff731281b7f682a1ca1d58ef7bd7f156.jpeg";